import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioForm';
import FormEntrada from './controlePatioEntradaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';
import Cookies from 'js-cookie';
import Excel from '../common/excel/excel';

import { 
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getListaHistorico as getLista,
	getListaMotorista, getListaPlaca, getListaLogs
} from './controlePatioActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';

const columns = [{
	field: 'id',
    type: 'int'
}, {
	field: 'shipping_saida',
    type: 'int'
}, {
    field: 'datahora_entrada',
    type: 'date'
}, {
    field: 'datahora_previsao_saida',
    type: 'date'
}, {
    field: 'datahora_saida',
    type: 'date'
}, {
    field: 'cavalo',
    type: 'text'
}, {
    field: 'carreta1',
    type: 'text'
}, {
    field: 'carreta2',
    type: 'text'
}, {
    field: 'nome_motorista',
    type: 'text'
}];

class ControlePatioHistorico extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'id',
			direction: 'asc'
		},
		statusVisiveis: JSON.parse(Cookies.get('controlePatioControleStatusVisiveis') || '[1, 2, 3]'),
		paginaAtual: 1,
		linhasPorPagina: 10,
		height: window.innerWidth < 685 ? window.innerHeight - 320 : window.innerHeight - 220
	}

	constructor(props) {
		super(props)

		this.scrollRefs = {}
		this.scrollIntervals = {}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaSetor();

		this.calcularLinhasPorPagina();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
	}

	componentDidUpdate() {
		const telaStatus = (window.location.href || '').includes('controlePatioStatus');

		if (telaStatus) {
			Object.keys(this.scrollRefs).forEach(id => {
				if (!this.scrollIntervals[id]) {
					this.startAutoScroll(id)
				}
			});
		} else {
			Object.values(this.scrollIntervals).forEach(interval =>
				clearInterval(interval)
			);
		}
	}

	componentWillUnmount() {
		Object.values(this.scrollIntervals).forEach(interval =>
			clearInterval(interval)
		);

		clearInterval(this.idIntervalAtualizacao);
	}

	calcularLinhasPorPagina = () => {
		const alturaDisponivel = this.state.height;
		const alturaLinha = 34.5;
		const quantidade = Math.floor(alturaDisponivel / alturaLinha);

		this.setState({ 
			linhasPorPagina: quantidade > 5 ? quantidade : 5 
		}); 
	}

	controleFavoritos(idStatus) {
		let lista = JSON.parse(Cookies.get('controlePatioControleStatusVisiveis') || '[1, 2, 3]');

		if (this.state.statusVisiveis.includes(idStatus)) {
			lista = lista.filter(item => item != idStatus);
		} else {
			lista.push(idStatus);
		}
		this.setState({ statusVisiveis: lista });

		Cookies.set('controlePatioControleStatusVisiveis', JSON.stringify(lista), { expires: 15 });
	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'historico' ? (
						<Form historico />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar_historico || '').trim()
				|| (this.props.filtro.pesquisar_historico.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.id}
						${item.shipping_saida}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}
						${item.cavalo}
						${item.carreta1}
						${item.carreta2}
						${item.nome_motorista}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	startAutoScroll(id) {
		
		const container = this.scrollRefs[id] ? this.scrollRefs[id].current : null
		if (!container) return

		if (container.scrollHeight <= container.clientHeight) return

		let direction = 1
		const speed = 1.0
		const delayAtEnd = 10000

		this.scrollIntervals[id] = setInterval(() => {

			container.scrollTop += speed * direction;

			if ((container.scrollTop + container.clientHeight) >= (container.scrollHeight - 10) && direction === 1) {
				setInterval(() => {
					direction = -1;
				}, delayAtEnd);
			}

			if (container.scrollTop <= 0 && direction === -1) {
				setInterval(() => {
					direction = 1;
				}, delayAtEnd);
			}

		}, 10);

	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		const { paginaAtual, linhasPorPagina } = this.state; 
		const totalPaginas = Math.ceil(lista.length / linhasPorPagina) || 1; 
		const inicio = (paginaAtual - 1) * linhasPorPagina; 
		const fim = inicio + linhasPorPagina; 
		const listaPaginada = lista.slice(inicio, fim);

		const heightTela = this.state.height;

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar_historico}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, pesquisar_historico: value });
								this.setState({
									paginaAtual: 1
								});
							}} />

						<LabelAndInputDate
							label='Data Inicial'
							cols='12 6 4 4'
							value={this.props.filtro.data_inicial_historico}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_inicial_historico: value
								});
							}} />

						<LabelAndInputDate
							label='Data Final'
							cols='12 6 4 4'
							value={this.props.filtro.data_final_historico}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_final_historico: value
								}); 
							}} />

						<Select
							options={[{ id: 'datahora_entrada', valor: 'Entrada' }, { id: 'datahora_previsao_saida', valor: 'Previsão Saída' }, { id: 'datahora_saida', valor: 'Saída' }]}
							label='Período'
							cols='12 1 1 1'
							minWidth={200}
							placeholder='Selecione'
							naoLimpar
							value={this.props.filtro.periodo_historico}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									periodo_historico: value
								});
							}} />


						<div style={{ width: 280, marginTop: 8, marginLeft: 8 }}>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista(true);
									this.setState({
										paginaAtual: 1
									});
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.gerarExcel(lista);
								}}>
								<i class='fas fa-file-excel'></i> Exportar
							</a>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.gerarExcelAtividades(lista);
								}}>
								<i class='fas fa-file-excel'></i> Atividades
							</a>
						</div>
					</Row>
					
					<div style={{ height: heightTela }}>
						<Table responsive border striped alturaFixa
							maxHeight={heightTela}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									
									<ThSort
										field='id'
										label='Num.'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />

									<ThSort
										field='shipping_saida'
										label='Shipping'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />
										
									<ThSort
										field='datahora_entrada'
										label='Entrada'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />		

									<ThSort
										field='datahora_previsao_saida'
										label='Previsão Saída'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />		

									<ThSort
										field='datahora_saida'
										label='Saída'
										width={100}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />		

									<ThSort
										field='cavalo'
										label='Cavalo'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />		
										
									<ThSort
										field='carreta1'
										label='Carreta 1'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />		

									<ThSort
										field='carreta2'
										label='Carreta 2'
										width={50}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />
										
									<ThSort
										field='nome_motorista'
										label='Motorista'
										width={200}
										sticky
										sort={this.state.sort}
										onSort={field => this.onSort(field)} />	

									<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={40} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{listaPaginada.map((item, i) => {
									return (
										<Tr key={i}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter small>{item.id}</Td>
											<Td color={'#000'} alignCenter small>{item.shipping_saida}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
											<Td color={'#000'} alignCenter small noWrap>{item.nome_motorista}</Td>
											<Td minWidth={10} width={10} alignCenter>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-eye'}
													visible={true}
													small
													event={() => {
														this.props.setModoTela('historico', {
															...item
														});
														this.props.getListaLogs(item.id);
														this.props.initForm({
															...item
														});													
													}} />
											</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
					</div>

					<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
						<div><strong>{lista.length}</strong> registros</div>
						<div style={{ display: 'flex', gap: 5 }}>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: 1 })}>
								<i class='fas fa-angle-double-left'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual === 1} 
								onClick={() => this.setState({ paginaAtual: paginaAtual - 1 })}>
								<i class='fas fa-angle-left'></i>
							</button>
							<span style={{ padding: '6px 12px', display: 'flex' }}>
								<div style={{ width: 30, textAlign: 'center' }}>{paginaAtual}</div> de <div style={{ width: 30, textAlign: 'center' }}>{totalPaginas}</div>
							</span>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: paginaAtual + 1 })}>
								<i class='fas fa-angle-right'></i>
							</button>
							<button className='btn btn-light' disabled={paginaAtual >= totalPaginas}
								onClick={() => this.setState({ paginaAtual: totalPaginas })}>
								<i class='fas fa-angle-double-right'></i>
							</button>
						</div>
					</div>

				</ContentCardBody>
			</ContentCard>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}

	gerarExcel(listaFiltrada) {

		Excel.exportar('Controle de Pátio',
			[{
				atributo: 'id',
				nome: 'Número Controle',
				largura: 15,
				formato: null
			}, {
				atributo: 'nome_status',
				nome: 'Status',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_criacao',
				nome: 'Criação',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_previsao_entrada',
				nome: 'Previsão Entrada',
				largura: 18,
				formato: null
			}, {
				atributo: 'datahora_previsao_saida',
				nome: 'Previsão Saída',
				largura: 18,
				formato: null
			}, {
				atributo: 'Entrada',
				nome: 'datahora_entrada',
				largura: 18,
				formato: null
			}, {
				atributo: 'observacao_entrada',
				nome: 'Observação Entrada',
				largura: 50,
				formato: null
			}, {
				atributo: 'shipping_saida',
				nome: 'Shipping',
				largura: 15,
				formato: null
			}, {
				atributo: 'rumo_saida',
				nome: 'Rumo',
				largura: 10,
				formato: null
			}, {
				atributo: 'cliente_saida',
				nome: 'Cliente',
				largura: 30,
				formato: null
			}, {
				atributo: 'fronteira_saida',
				nome: 'Fronteira',
				largura: 30,
				formato: null
			}, {
				atributo: 'destino_saida',
				nome: 'Destino',
				largura: 30,
				formato: null
			}, {
				atributo: 'lote_crt_saida',
				nome: 'Lote',
				largura: 20,
				formato: null
			}, {
				atributo: 'carga_classificada_saida',
				nome: 'Classificada',
				largura: 15,
				formato: null
			}, {
				atributo: 'expresso_saida',
				nome: 'Expressa',
				largura: 15,
				formato: null
			}, {
				atributo: 'nome_usuario_entrada',
				nome: 'Usuário Entrada',
				largura: 15,
				formato: null
			}, {
				atributo: 'localizacao',
				nome: 'Localização',
				largura: 30,
				formato: null
			}],
			listaFiltrada.map(item => ({
				...item,
				datahora_criacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_criacao),
				datahora_previsao_entrada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrada),
				datahora_previsao_saida: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida),
				datahora_entrada: DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrada)
			}))
		);
	}

	gerarExcelAtividades(listaFiltrada) {

		const listaAtividades = [];

		listaFiltrada.forEach(item => {

			(item.fichas_setores_completa || []).forEach(ficha => {

				/*
				* Considera como atividade realizada:
				* - teve execução
				* - ou foi liberada
				* - ou possui início/fim calculado
				*
				* Assim também entram os casos de liberação sem execução.
				*/
				const realizada =
					ficha.possui_execucao
					|| ficha.possui_liberacao
					|| ficha.datahora_inicio_execucao
					|| ficha.datahora_fim_execucao;

				if (!realizada) {
					return;
				}

				listaAtividades.push({

					numero_controle: item.id,

					nome_ficha: item.cavalo || item.carreta || item.nome_motorista,

					atividade: ficha.nome_setor,

					datahora_inicio: ficha.datahora_inicio_execucao
						? DateFormat.formatarDataHoraSqlParaTela(
							ficha.datahora_inicio_execucao
						)
						: '',

					datahora_fim: ficha.datahora_fim_execucao
						? DateFormat.formatarDataHoraSqlParaTela(
							ficha.datahora_fim_execucao
						)
						: '',

					tempo_execucao: ficha.tempo_execucao || '0 min',

					tempo_execucao_segundos: Number(
						ficha.tempo_execucao_segundos || 0
					)

				});

			});

		});


		Excel.exportar(
			'Controle de Pátio - Atividades',

			[
				{
					atributo: 'numero_controle',
					nome: 'Número Controle',
					largura: 15,
					formato: null
				},{
					atributo: 'nome_ficha',
					nome: 'Ficha',
					largura: 20,
					formato: null
				},
				{
					atributo: 'atividade',
					nome: 'Atividade',
					largura: 30,
					formato: null
				},
				{
					atributo: 'datahora_inicio',
					nome: 'Data/Hora Início',
					largura: 20,
					formato: null
				},
				{
					atributo: 'datahora_fim',
					nome: 'Data/Hora Fim',
					largura: 20,
					formato: null
				},
				{
					atributo: 'tempo_execucao',
					nome: 'Tempo',
					largura: 20,
					formato: null
				},
				{
					atributo: 'tempo_execucao_segundos',
					nome: 'Tempo em Segundos',
					largura: 18,
					formato: null
				}
			],

			listaAtividades
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTela,
	lista: state.controlePatio.listaHistorico,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus,
	listaRumo: state.controlePatio.listaRumo,
	listaAtraso: state.controlePatio.listaAtraso
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getLista,
	getListaMotorista, getListaPlaca, getListaSetor, getListaLogs
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioHistorico);
